
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vip",
      function () {
        return require("private-next-pages/vip.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vip"])
      });
    }
  